import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const WarningIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M8.77 12.7c0 .42-.35.79-.77.79-.42 0-.77-.37-.77-.79 0-.42.37-.77.77-.77s.77.37.77.77Zm-.18-6.88v5.25H7.42V5.82h1.17Z" />
    <path d="m8 2.62 6.33 11.88H1.67L8 2.62ZM8 .5l-8 15h16L8 .5Z" />
    <defs>
      <path d="M0 0h16v16H0z" />
    </defs>
  </IconWrapper>
)

export default WarningIconSmall
